var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12.834C19 12.282 19.448 11.834 20 11.834C20.552 11.834 21 12.282 21 12.834V18.4C21 19.834 19.833 21.001 18.4 21.001H5.6C4.167 21.001 3 19.834 3 18.4V5.60098C3 4.16698 4.167 3.00098 5.6 3.00098H15.167C15.719 3.00098 16.167 3.44798 16.167 4.00098C16.167 4.55298 15.719 5.00098 15.167 5.00098H5.6C5.269 5.00098 5 5.26998 5 5.60098V18.4C5 18.731 5.269 19.001 5.6 19.001H18.4C18.731 19.001 19 18.731 19 18.4V12.834ZM9.3096 10.947C9.7096 10.565 10.3416 10.581 10.7236 10.98L12.2286 12.558L18.2816 6.30498C18.6646 5.90898 19.2976 5.89698 19.6956 6.28198C20.0926 6.66598 20.1026 7.29898 19.7186 7.69598L12.9416 14.696C12.7536 14.891 12.4946 15.001 12.2236 15.001H12.2196C11.9476 15 11.6876 14.888 11.4996 14.691L9.2766 12.361C8.8946 11.961 8.9106 11.328 9.3096 10.947Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_917_10587",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12.834C19 12.282 19.448 11.834 20 11.834C20.552 11.834 21 12.282 21 12.834V18.4C21 19.834 19.833 21.001 18.4 21.001H5.6C4.167 21.001 3 19.834 3 18.4V5.60098C3 4.16698 4.167 3.00098 5.6 3.00098H15.167C15.719 3.00098 16.167 3.44798 16.167 4.00098C16.167 4.55298 15.719 5.00098 15.167 5.00098H5.6C5.269 5.00098 5 5.26998 5 5.60098V18.4C5 18.731 5.269 19.001 5.6 19.001H18.4C18.731 19.001 19 18.731 19 18.4V12.834ZM9.3096 10.947C9.7096 10.565 10.3416 10.581 10.7236 10.98L12.2286 12.558L18.2816 6.30498C18.6646 5.90898 19.2976 5.89698 19.6956 6.28198C20.0926 6.66598 20.1026 7.29898 19.7186 7.69598L12.9416 14.696C12.7536 14.891 12.4946 15.001 12.2236 15.001H12.2196C11.9476 15 11.6876 14.888 11.4996 14.691L9.2766 12.361C8.8946 11.961 8.9106 11.328 9.3096 10.947Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_917_10587)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#6A5EF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFilled);
export default __webpack_public_path__ + "static/media/checkbox-filled.70f23e9f10155d82b5ae91af7cce37ef.svg";
export { ForwardRef as ReactComponent };